// FIXME: This file is just an example, please take it as reference to make your own.

import { GET_AUTH_INFO_SUCCESS } from '../AuthorizationProvider/AuthorizationProvider.actions'
import { UPDATE_NAME_SUCCESS } from './HeaderSection.actions'

const headerSectionState = { name: '' }

/**
 * The header section's reducer.
 */
const headerSectionReducer = (state = headerSectionState, { payload, type }) => {
  switch (type) {
    case GET_AUTH_INFO_SUCCESS: {
      return { ...state, name: payload.authInfo.userName }
    }
    case UPDATE_NAME_SUCCESS: {
      return { ...state, name: payload.name }
    }
    default: {
      return state
    }
  }
}

export default headerSectionReducer
